import { AfterViewInit, Component, OnDestroy } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { IColumn, IItem } from '@coreui/angular-pro';
import { endOfMonth, endOfWeek, startOfMonth, startOfWeek, startOfYear, subMonths, subWeeks } from 'date-fns';
import { filter, finalize, takeUntil } from 'rxjs';
import { PipelineDashboardControler } from 'src/Controler/Pipeline.controler';
import { PipelineDashboardData, pipelineConsultant, pipelineLineCharts, pipelinePieCharts, pipelineStats } from 'src/Models/pipeline.model';
import { environment } from 'src/environments/environment';
import { helperFunctions } from 'src/helperfunctions';
import { ErrorNotificationService, LookupListsService, PipelineService, RetrieveTokenService } from 'src/services';
import { PipelineColorDictionary, hexToRgba } from 'src/assets/colours';

@Component({
  selector: 'app-pipeline-dashboard',
  standalone: false,
  templateUrl: './pipeline-dashboard.component.html',
  styleUrls: ['./pipeline-dashboard.component.scss'],
  template: ''
})
export class PipelineDashboardComponent implements AfterViewInit, OnDestroy{
  //#region start Variables
  public stages = ['Prospect', 'Contacted', 'Visited', 'Proposal', 'Won', 'Lost'];
  public ShowRawDataPopupVisible = false;
  public tableRawData: IItem[] = [];
  public tableRawDataColumns: (string|IColumn)[] = [{key: 'Customer_Name'},
  {key: 'Routing'},
  {key: 'Product_Type'},
  {key: 'Volume'},
  {key: 'Unit'},
  {key: 'Expected_GP'},
  {key: 'Stage'},
  {key: 'Sales_Rep'},
  {key: 'Comment'}];
  public productType:string = '';
  private portifolioSelectedStage:string = environment.pipeline.pipelineStageTypeIds.Prospect;

  private pipeControler?:PipelineDashboardControler;
  public dataFilters: FormGroup;
  public pipelineRadioGroup = new UntypedFormGroup({
    pipelineRadio: new UntypedFormControl('Expected GP')
  });
  public weekNumbers: string[] = [];
  public consultantList: pipelineConsultant[] = [];
  public countryList: string[] = [];
  public officeList: string[] = [];
  public calendarDate = new Date(Date.now());
  public locale:string = navigator.language;
  public startDate:Date | null = startOfWeek(subWeeks(new Date(), 4), {weekStartsOn: 1});//new Date(this.calendarDate.getFullYear(), this.calendarDate.getMonth(), 1);
  public endDate:Date | null = endOfWeek(new Date(), {weekStartsOn: 1});
  public loading = new Array(1);
  public lookupListLoading = [true, true, true, true];
  public chartsLoading = true;
  public selectAllStages = false;
  private readonly apiErrorOccurred = this.errorNotifications.currentError.pipe(
    filter(error => error !== null)
  );
  public btnFilterValue = this.fb.group({
    filterRadioValue: this.fb.control('None')
  });
  //#region ChartVariables

  PipelineBarChartref:any;
  PipelineBarData = {
    labels: this.stages,//, 'Future Prospect'
    datasets: [
      {
        label: 'Count',
        backgroundColor: this.stages.map(itm => hexToRgba(PipelineColorDictionary[itm], 0.7)),
        borderColor: this.stages.map(itm => PipelineColorDictionary[itm]),
        borderWidth: 1,
        maxBarThickness: 40,
        minBarLength: 5,
        data: [0]
      }
    ]
  };

  PipelinePortifolioChartref:any;
  public PipelinePortifolioData = {
    labels: [""],
    datasets: [
      {
        //label: "Percentage",
        data: [0],
        backgroundColor: ['#FF1111', '#36A2EB', '#FFCE56',
        'rgba(153, 102, 255, 0.7)',
        'rgba(201, 203, 207, 0.7)',
        'rgba(75, 192, 192, 0.7)'],
        hoverBackgroundColor: ['#FF4345', '#36A2EB', '#FFCE56',
        'rgba(153, 102, 255)',
        'rgba(201, 203, 207)',
        'rgba(75, 192, 192)'],

      }
    ]
  };

  pipelineActivityChartref:any;
  public pipelineActivityData = {
    labels: [] as string[],
    datasets:
    this.stages.map(itm => {
      return {
        label: itm,
        backgroundColor: hexToRgba(PipelineColorDictionary[itm], 0.7),
        borderColor: PipelineColorDictionary[itm],
        //pointBackgroundColor: PipelineColorDictionary[itm],
        //pointBorderColor: '#fff',
        data: [0]
      }
    }),
  }
  Pipelinestats!: pipelineStats;

  //#endregion
  //#endregion

  //#region constructors
  constructor (private retreiveTokenService: RetrieveTokenService, private lookupLists:LookupListsService, private fb:FormBuilder, private pipelineDashboardService:PipelineService, private route: ActivatedRoute, private helper: helperFunctions, private errorNotifications: ErrorNotificationService){
    this.dataFilters = this.fb.group({
      weekNumbers: this.fb.array([]),
      consultantList: this.fb.array([]),
      officeList: this.fb.array([]),
      countryList: this.fb.array([]),
    });
  }
  ngAfterViewInit(): void {

    this.retreiveTokenService.getToken.subscribe(s =>{
      if (s != ""){
        this.loadPage();
      }
    });

    let id = this.route.snapshot.paramMap.get('id');
    if (id != null){
      this.pipelineDashboardService.PipelineDashboardSecurity(id).subscribe(s =>{
        let loggedInConsultantID = s.consultantID;
        this.retreiveTokenService.setloggedInConsultantID = loggedInConsultantID;
        this.retreiveTokenService.setToken = s.token;
      });
    }
    //else redirect to 404 (ToDo add 404)
  }

  ngOnDestroy(): void {
    //this.retreiveTokenService.getToken.unsubscribe();
  }
  //#endregion

  //Data filter setters. Form control and naming arrays

  setFilterBtnValue(value: string): void {
    this.btnFilterValue.setValue({ filterRadioValue: value });
    let oldStartDate = this.startDate;
    let oldEndDate = this.endDate;
    switch (value){
      case "CurrentYTD":{
        this.startDate = startOfYear(new Date());
        this.endDate = new Date();
        break;
      }
      case "CurrentMonth":{
        this.startDate = startOfMonth(new Date());
        this.endDate = endOfMonth(new Date());
        break;
      }
      case "LastMonth":{
        this.startDate = startOfMonth(subMonths(new Date(), 1));
        this.endDate = endOfMonth(subMonths(new Date(), 1));
        break;
      }
      case "CurrentWeek":{
        this.startDate = startOfWeek(new Date(), {weekStartsOn: 1});
        this.endDate = endOfWeek(new Date(), {weekStartsOn: 1});
        break;
      }
      case "LastWeek":{
        this.startDate = startOfWeek(subWeeks(new Date(), 1), {weekStartsOn: 1});
        this.endDate = endOfWeek(subWeeks(new Date(), 1), {weekStartsOn: 1});
        break;
      }
      default:{
        this.startDate = startOfWeek(subWeeks(new Date(), 4), {weekStartsOn: 1});
        this.endDate = endOfWeek(new Date(), {weekStartsOn: 1});
      }
    }

    if (oldStartDate?.getDate() != this.startDate?.getDate() && oldEndDate?.getDate() == this.endDate?.getDate()){
      this.loadPage();
    }
  }

  private setList( lst:any[], lstName:string){
    switch (lstName) {
      case "consultantList":{
        this.consultantList = lst;
        this.getFormConsultantList.clear();
        if (lst)
          this.consultantList.forEach((itm) => this.getFormConsultantList.push(new FormControl(true)));//{text: itm, value:true}
        break;}
      case "weekNumbers":{
        this.weekNumbers = lst;
        this.getFormWeekNumbers.clear();
        if (lst)
          this.weekNumbers.forEach((itm) => this.getFormWeekNumbers.push(new FormControl(true)));//{text: itm, value:true}
        break;}
      case "officeList":{
        this.officeList = lst;
        this.getFormOfficeList.clear();
        if (lst)
          this.officeList.forEach((itm) => this.getFormOfficeList.push(new FormControl(true)));//{text: itm, value:true}
        break;}
      case "countryList":{
        this.countryList = lst;
        this.getFormCountriesList.clear();
        if (lst)
          this.countryList.forEach((itm) => this.getFormCountriesList.push(new FormControl(true)));//{text: itm, value:true}
        break;}
      default:{
        console.log("default");}
    }
  }

  //#region Data filter form array getter.
  public get getFormWeekNumbers(){
    return this.dataFilters.controls['weekNumbers'] as FormArray;
  }

  public get getFormConsultantList(){
    return this.dataFilters.controls['consultantList'] as FormArray;
  }

  public get getFormOfficeList(){
    return this.dataFilters.controls['officeList'] as FormArray;
  }

  public get getFormCountriesList(){
    return this.dataFilters.controls['countryList'] as FormArray;
  }

  public getCheckedItems(formList:FormArray, dataList:any[]):string[]{
    let oList = [];
    for (let i = 0; i < formList.controls.length; i++){
      let itm = formList.controls[i];
      if (itm.value){
        if (dataList[i].consultantID){
          oList.push(dataList[i].consultantID);
        } else {
          oList.push(dataList[i]);
        }
      }
    }
    return oList;
  }

  public get lookupLoading(){
    return this.lookupListLoading.reduce((acc, curr) => acc||curr);
  }
  //#endregion getters

  public loadPage(){ //page load calls
    this.reloadFilters();
    this.getPipelineDashData();
  }

  //#region Checkbox toggle function

  public setValues(controlName: number, lstName:String, event: MouseEvent) {//Toggle Check buttons.
    if ((event.ctrlKey && event.shiftKey) || event.shiftKey){
      switch (lstName) {
      case "consultantList":{
        this.shiftToggel(this.getFormConsultantList, controlName);
        break;}
      case "weekNumbers":{
        this.shiftToggel(this.getFormWeekNumbers, controlName);
        this.getPipelineCountries(true);
        break;}
      case "officeList":{
        this.shiftToggel(this.getFormOfficeList, controlName);
        this.getPipelineConsultants(true);
        break;}
      case "countryList":{
        this.shiftToggel(this.getFormCountriesList, controlName);
        this.getPipelineOffices(true);
        break;}
      default:{
        console.log("default");}
      }
    } else if (event.ctrlKey ){
      switch (lstName) {
        case "consultantList":{
          this.ctrToggel(this.getFormConsultantList, controlName);
          break;}
        case "weekNumbers":{
          this.shiftToggel(this.getFormWeekNumbers, controlName);
          this.getPipelineCountries(true);
          break;}
        case "officeList":{
          this.ctrToggel(this.getFormOfficeList, controlName);
          this.getPipelineConsultants(true);
          break;}
        case "countryList":{
          this.ctrToggel(this.getFormCountriesList, controlName);
          this.getPipelineOffices(true);
          break;}
        default:{
          console.log("default");}
        }
    } else {
      switch (lstName) {
        case "consultantList":{
          this.normalToggel(this.getFormConsultantList, controlName);
          break;}
        case "weekNumbers":{
          this.normalToggel(this.getFormWeekNumbers, controlName);
          this.getPipelineCountries(true);
          break;}
        case "officeList":{
          this.normalToggel(this.getFormOfficeList, controlName);
          this.getPipelineConsultants(true);
          break;}
        case "countryList":{
          this.normalToggel(this.getFormCountriesList, controlName);
          this.getPipelineOffices(true);
          break;}
        default:{
          console.log("default");}
        }
    }
    this.getPipelineDashData(true);
  }

  private ctrToggel(formArr: FormArray, controlName: number){
    const prevValue1 = formArr.get(controlName.toString())?.value;
    if (prevValue1){
      let count = 0;
      formArr.controls.forEach(element => {
        if (element.value)
          count += 1;
      });
      if (count > 1){
        formArr.controls[controlName].setValue(!prevValue1);
      }
    } else {
      formArr.controls[controlName].setValue(!prevValue1);
    }
  }

  private shiftToggel(formArr: FormArray, controlName: number){
    let min = -1;
    let max = 0;
    for(let i = 0; i < formArr.controls.length; i++){
      if (formArr.get(i.toString())?.value === true){
        if (min == -1){
          min = i;
        }
        max = i;
      }
    }
    formArr.controls.forEach( itm => itm.setValue(false));
    if (controlName < min){
      for (let i = 0; i < formArr.controls.length; i++){
        formArr.controls[i].setValue( controlName <= i && i <= min);
      }
    } else if (controlName > max){
      for (let i = 0; i < formArr.controls.length; i++){
        formArr.controls[i].setValue( min <= i && i <= controlName);
      }
    } else if (min < controlName && controlName < max){
      for (let i = 0; i < formArr.controls.length; i++){
        formArr.controls[i].setValue( min <= i && i <= controlName);
      }
    } else {
      formArr.controls[controlName].setValue(true);
    }
  }

  private normalToggel(formArr: FormArray, controlName: number){
    formArr.controls.forEach( itm => itm.setValue(false));
    formArr.controls[controlName].setValue(true);
  }

  public togglePipelineDisplayedData(value: string) {
    this.pipelineRadioGroup.setValue({ pipelineRadio: value });
    this.PipelineBarData.datasets[0].label = value;
    if (value === 'Count'){
      this.PipelineBarData.datasets[0].data = this.Pipelinestats.toCountArray;
    } else {
      this.PipelineBarData.datasets[0].data = this.Pipelinestats.toGPArray;
    }
    this.PipelineBarChartref.update();
  }

  public toggelSelectAll(){
    this.selectAllStages = !this.selectAllStages;
    this.reloadFilters();
    this.getPipelineDashData();
  }

  public reloadFilters(){
    if (this.endDate && this.retreiveTokenService.getloggedInConsultantID != ''){
      this.getPipelineWeekNumbers();
      this.getPipelineCountries();
      this.getPipelineOffices();
      this.getPipelineConsultants();
    }
  }
//#endregion checkbox controls

  public ShowRawProductDataPopup(eve: any){
    if(eve[0] != undefined){
      if (this.pipeControler){
        this.productType = "Product: " + this.PipelinePortifolioChartref.data.labels[eve[0].index];
        this.tableRawData = this.pipeControler.getRawData(undefined, this.PipelinePortifolioChartref.data.labels[eve[0].index]);
        this.toggleRawDataPopupVisible();
      }
    }
  }

  public ShowRawStageDataPopup(eve: any){
    if (this.pipeControler){
      this.portifolioSelectedStage = Object.entries(environment.pipeline.pipelineStageTypeIds)[eve[0].index][1];

      this.productType = "Stage: " + this.PipelineBarData.labels[eve[0].index];
      this.tableRawData = this.pipeControler.getRawData(this.portifolioSelectedStage);
      if(this.tableRawData.length > 0){
        this.toggleRawDataPopupVisible();
      }
    }
  }

  public toggleRawDataPopupVisible(){
    this.ShowRawDataPopupVisible = !this.ShowRawDataPopupVisible;
  }

  //#region get Chart references to update later
 handleChartRefBar($chartRef: any) { //ToDo: Possibly delete.
    if ($chartRef) {
      this.PipelineBarChartref = $chartRef;
    }
  }

  handleChartRefPie($chartRef: any) { //ToDo: Possibly delete.
    if ($chartRef) {
      this.PipelinePortifolioChartref = $chartRef;
    }
  }

  handleChartRefActivity($chartRef: any) { //ToDo: Possibly delete.
    if ($chartRef) {
      this.pipelineActivityChartref = $chartRef;
    }
  }
  //#endregion references section

  private getDates(filtered:boolean = false){
    let dates:{startDate: Date, endDate:Date} = {startDate: new Date(), endDate: new Date()};
    if(this.startDate && this.endDate){
      if (filtered){
        dates = this.helper.getDatesFromWeekNumber(this.getCheckedItems(this.getFormWeekNumbers, this.weekNumbers), this.startDate.getFullYear(), this.endDate.getFullYear());
      } else {
        dates.startDate = this.startDate;
        dates.endDate = this.endDate;
      }
    }
    return dates;
  }

  //#region Service calls:
  public getPipelineDashData(filtered:boolean = false){
    let tempConsultantList = undefined;
    let tempCoutriesList = undefined;
    let tempOfficeList = undefined;
    this.chartsLoading = true;

    if (!!this.loading[0]) {
      this.loading[0] = undefined;
    } else {
      this.loading[0] = 3000000;
    }
    let dates = this.getDates(filtered);

    if(filtered){
      if(!this.startDate){
        alert("Please select a start date to search.");
        this.chartsLoading = false;
        this.loading[0] = undefined;
        return;
      }
      if(!this.endDate){
        alert("Please select an end date to search.");
        this.chartsLoading = false;
        this.loading[0] = undefined;
        return;
      }
      tempCoutriesList = this.getCheckedItems(this.getFormCountriesList, this.countryList);
      tempOfficeList = this.getCheckedItems(this.getFormOfficeList, this.officeList);
      tempConsultantList = this.getCheckedItems(this.getFormConsultantList, this.consultantList);
    }

    this.pipelineDashboardService.getPipelineData(this.retreiveTokenService.getloggedInConsultantID, this.selectAllStages, dates.startDate, dates.endDate, tempConsultantList, tempCoutriesList, tempOfficeList).pipe(
      takeUntil(this.apiErrorOccurred),
      finalize(() => {
        this.loading[0] = undefined;
        this.chartsLoading = false;
      })
    ).subscribe((data: PipelineDashboardData[])=> {
      this.pipeControler = new PipelineDashboardControler(data);
      //Bar
      this.Pipelinestats = this.pipeControler.PipelineStats();
      this.PipelineBarData.datasets[0].data = this.pipelineRadioGroup.getRawValue()["pipelineRadio"] === 'Expected GP'? this.Pipelinestats.toGPArray : this.Pipelinestats.toCountArray;
      this.PipelineBarData.datasets[0].label = this.pipelineRadioGroup.getRawValue()["pipelineRadio"];
      this.PipelineBarChartref?.update();

      //Pie
      let tempPieData:pipelinePieCharts = this.Pipelinestats.pipelinePortifolio;
      this.PipelinePortifolioData.labels = tempPieData.getDataLables;
      this.PipelinePortifolioData.datasets[0].data = tempPieData.dataSetToPercentage;
      this.PipelinePortifolioChartref?.update();

      //Line
      let tempLineData:pipelineLineCharts = this.pipeControler.PipelineActivity(this.startDate, this.endDate);
      this.pipelineActivityData.labels = tempLineData.dates;
      Object.entries(environment.pipeline.pipelineStageTypeIds).forEach(([key, value], idx) => {
        this.pipelineActivityData.datasets[idx].data = tempLineData.getDataByLabel(value);
      });
      this.pipelineActivityChartref?.update();
    });
  }

  public getPipelineWeekNumbers(){
    this.lookupListLoading[0] = true;
    this.setList([], "weekNumbers");
    this.lookupLists.pipelineLookup.PipelineWeekNumbers(this.retreiveTokenService.getloggedInConsultantID, this.startDate, this.endDate).pipe(
      takeUntil(this.apiErrorOccurred),
      finalize(() => this.lookupListLoading[0] = false)
    ).subscribe( (data: any)=> {
      this.setList(data, "weekNumbers");
    });
  }

  public getPipelineCountries(filtered:boolean = false){
    this.lookupListLoading[1] = true;
    this.setList([], "countryList");
    let dates = this.getDates(filtered);
    this.lookupLists.pipelineLookup.PipelineCountries(this.retreiveTokenService.getloggedInConsultantID, dates.startDate, dates.endDate).pipe(
      takeUntil(this.apiErrorOccurred),
      finalize(() => this.lookupListLoading[1] = false)
    ).subscribe( (data: any)=> {
      this.setList(data, "countryList");
      if(filtered){
        this.getPipelineOffices(filtered);
      }
    });
  }

  public getPipelineOffices(filtered:boolean = false){
    this.lookupListLoading[2] = true;
    this.setList([], "officeList");
    let coutriesList = undefined;
    if (filtered){
      coutriesList = this.getCheckedItems(this.getFormCountriesList, this.countryList);
    }
    let dates = this.getDates(filtered);
    this.lookupLists.pipelineLookup.PipelineOffices(this.retreiveTokenService.getloggedInConsultantID, dates.startDate, dates.endDate, coutriesList).pipe(
      takeUntil(this.apiErrorOccurred),
      finalize(() => this.lookupListLoading[2] = false)
    ).subscribe( (data: any)=> {
      this.setList(data, "officeList");
      if (filtered){
        this.getPipelineConsultants(true);
        console.log(this.getFormConsultantList);
      }
    });
  }

  private getPipelineConsultants(filtered:boolean = false){
    this.lookupListLoading[3] =true;
    this.setList([], "consultantList");
    let tempCoutriesList = undefined;
    let tempOfficeList = undefined;
    if (filtered){
      tempCoutriesList = this.getCheckedItems(this.getFormCountriesList, this.countryList);
      tempOfficeList = this.getCheckedItems(this.getFormOfficeList, this.officeList);
    }
    let dates = this.getDates(filtered);
    this.lookupLists.pipelineLookup.PipelineConsultants(this.retreiveTokenService.getloggedInConsultantID, dates.startDate, dates.endDate, tempCoutriesList, tempOfficeList).pipe(
      takeUntil(this.apiErrorOccurred),
      finalize(() => this.lookupListLoading[3] = false)
    ).subscribe( (data: pipelineConsultant[])=> {
      this.setList(data, "consultantList");
    });
  }
  //#endregion
}